if (process.env.NODE_ENV === "development") {
    window.env = {
        REACT_APP_API_URL: "https://notification-engine-api.dev.apps.coming.rs/api/NotificationEngine/",
        REACT_APP_KEYCLOAK_URL: "https://keycloak.dev.apps.coming.rs",
        REACT_APP_KEYCLOAK_CLIENT_ID: "NotificationEngine.UI",
        REACT_APP_KEYCLOAK_REALM: "Coming-DEV",
    }
}

export const env = { ...process.env, ...window['env'] }